/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OfferFormViewModel,
    OfferFormViewModelFromJSON,
    OfferFormViewModelFromJSONTyped,
    OfferFormViewModelToJSON,
} from './OfferFormViewModel';

/**
 * 
 * @export
 * @interface OfferFormViewModelPagedDataModel
 */
export interface OfferFormViewModelPagedDataModel {
    /**
     * 
     * @type {number}
     * @memberof OfferFormViewModelPagedDataModel
     */
    pageNo?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferFormViewModelPagedDataModel
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferFormViewModelPagedDataModel
     */
    readonly rowIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferFormViewModelPagedDataModel
     */
    readonly pageCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferFormViewModelPagedDataModel
     */
    itemCount?: number;
    /**
     * 
     * @type {Array<OfferFormViewModel>}
     * @memberof OfferFormViewModelPagedDataModel
     */
    data?: Array<OfferFormViewModel> | null;
}

export function OfferFormViewModelPagedDataModelFromJSON(json: any): OfferFormViewModelPagedDataModel {
    return OfferFormViewModelPagedDataModelFromJSONTyped(json, false);
}

export function OfferFormViewModelPagedDataModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferFormViewModelPagedDataModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pageNo': !exists(json, 'pageNo') ? undefined : json['pageNo'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'rowIndex': !exists(json, 'rowIndex') ? undefined : json['rowIndex'],
        'pageCount': !exists(json, 'pageCount') ? undefined : json['pageCount'],
        'itemCount': !exists(json, 'itemCount') ? undefined : json['itemCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(OfferFormViewModelFromJSON)),
    };
}

export function OfferFormViewModelPagedDataModelToJSON(value?: OfferFormViewModelPagedDataModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pageNo': value.pageNo,
        'pageSize': value.pageSize,
        'itemCount': value.itemCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(OfferFormViewModelToJSON)),
    };
}

